<template>
    <research-graph-block
        graph-title="名医经验知识图谱"
        table-title="名医经验三元组表格"
        :chart-data="chartData"
        :page-size="10"
        :node-limit="50"
    />
</template>

<script>
import ResearchGraphBlock from './research_graph_block.vue';

export default {
    name: 'DoctorExperience',
    components: { ResearchGraphBlock },
    props: {
        chartData: {
            type: Object,
            default: () => ({ nodes: [], edges: [], triples: [] }),
        },
    },
};
</script>
